const MarkAllAsReadSvg = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="17"
            height="16"
            viewBox="0 0 17 16"
            fill="none"
        >
            <g clipPath="url(#clip0_19310_80838)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.8588 3.596L8.05377 12.81L7.32577 12.777L4.23877 8.382L4.99277 7.852L7.73677 11.759L15.1558 3L15.8588 3.596Z"
                    fill="#828282"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.47277 8.774L11.8588 3.596L11.1558 3L6.92577 7.994L7.47277 8.774ZM4.30577 11.087L4.85277 11.867L4.05377 12.81L3.32577 12.777L0.23877 8.382L0.99277 7.852L3.73677 11.759L4.30577 11.087Z"
                    fill="#828282"
                />
            </g>
            <defs>
                <clipPath id="clip0_19310_80838">
                    <rect width="16" height="16" fill="white" transform="translate(0.23877)" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default MarkAllAsReadSvg;
